import * as React from 'react';

const MinusSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="minus_svg__eds-icon--minus_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="minus_svg__eds-icon--minus_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M2.6 11.5h18.8v1H2.6z"
        />
    </svg>
);

MinusSvg.displayName = 'MinusSvg';
export default MinusSvg;
